
interface ApiConfig {
    API: string;
}

interface Config {
  api: ApiConfig;
}

const config: Config = {
  api: {
    API: process.env.REACT_APP_API || "",
  },

};

export default config;
